// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__Bk3Ju","loading__icon":"Loading_loading__icon__azoJo"};